import { sharingSteps } from './ProjectSharing';
import { ProjectSharingHeader } from './ProjectSharingHeader';
import styles from './project-sharing.module.less';
import { ProjectSharingFooter } from './ProjectSharingFooter';
import { MarkAsCompleteButton } from './ProjectSharingMarkAsComplete';
import { trackEvent } from '../../support-and-tracking/analytics-actions';
import { getUrlFromShortlink } from '../../shortlink/shortlink-model';
import Image from '../../components/image/Image';
import CopyLinkButton from '../../components/button/copy-link-button/CopyLinkButton';

export const ProjectSharingCommunity = ({ setSharingStepComplete, project, completed, shortlink }) => {
    const footerBackLink = `/project/${project.id}/sharing/3`;
    const footerBackLinkText = 'Støttespillere';
    const footerForwardLink = `/project/${project.id}/sharing/5`;
    const footerForwardLinkText = 'Instagram';
    const urlToShare = shortlink ? getUrlFromShortlink(shortlink) : `https://spleis.no/${project.id}`;
    return (
        <>
            <ProjectSharingHeader
                title="Del i grupper og fellesskap"
                backLink={`/project/${project.id}/sharing`}
                backLinkText="Tilbake til delingspanelet"
            />
            <section className={styles.contentPanel}>
                <div className={styles.fullWidth}>
                    <Image
                        className={styles.topImage}
                        src="people-illustrations/group-chilling.svg"
                        alt="4 personer som hygger seg sammen"
                    />
                </div>
                <p>Del innsamlingen din i grupper som kan ha nytte av den.</p>
                <ul className={styles.checkmarkList}>
                    <li>Grupper på facebook</li>
                    <li>Forumer og nettsamfunn</li>
                    <li>Blogger</li>
                    <li>Lokalaviser</li>
                    <li>Klubber eller lag som heier på innsamlingen</li>
                </ul>
                <p className={styles.listAligned}>
                    <em>Kommer du på noen flere?</em>
                </p>

                <CopyLinkButton
                    link={urlToShare}
                    callback={() =>
                        trackEvent('admin', 'project-share', {
                            channel: 'copy-url',
                            activity: 'community',
                            'project-id': project.id,
                        })
                    }
                />
                <MarkAsCompleteButton
                    completed={completed}
                    onClick={() => {
                        setSharingStepComplete(sharingSteps.community);
                        trackEvent('shareguide', 'step-complete', {
                            activity: 'community',
                            'project-id': project.id,
                        });
                    }}
                />
            </section>
            <ProjectSharingFooter
                backLink={footerBackLink}
                backLinkText={footerBackLinkText}
                forwardLink={footerForwardLink}
                forwardLinkText={footerForwardLinkText}
            />
        </>
    );
};
